import { render, staticRenderFns } from "./ContentPagination.vue?vue&type=template&id=57133e9a&"
import script from "./ContentPagination.vue?vue&type=script&lang=js&"
export * from "./ContentPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports